import { render, staticRenderFns } from "./AdministrationContainer.vue?vue&type=template&id=3f41a93d"
import script from "./AdministrationContainer.vue?vue&type=script&lang=js"
export * from "./AdministrationContainer.vue?vue&type=script&lang=js"
import style0 from "./AdministrationContainer.vue?vue&type=style&index=0&id=3f41a93d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports